// Ticket 79 (feedback Sam): standaard alleen de zoekbalk — de oefeningen met
// hun notities verschijnen pas wanneer je (een deel van) de naam typt.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "group"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    this.groupTargets.forEach(group => {
      const name = (group.dataset.name || "").toLowerCase()
      const match = query !== "" && name.includes(query)
      group.classList.toggle("hidden", !match)
      if (match) {
        group.setAttribute("open", "open")
      } else {
        group.removeAttribute("open")
      }
    })
  }
}
